export function useGalleryModal() {
  const isOpen = ref(false);
  const startIndex = ref(0);

  function open(index: number): void {
    startIndex.value = index;
    isOpen.value = true;
  }

  function close(): void {
    isOpen.value = false;
  }

  return {
    isOpen,
    startIndex,
    open,
    close,
  };
}
